module.exports = __webpack_public_path__ + "media/images/icons/SVG/067-fc161d0153adbb176564748fa18c8e98.svg";